var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "form",
      attrs: { novalidate: "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.sendToPreview.apply(null, arguments)
        },
      },
    },
    [
      _c("ValidationAlert", {
        attrs: { "error-list": _vm.errors.collect("server") },
      }),
      _vm._v(" "),
      _c(
        "fieldset",
        { staticClass: "form__group" },
        [
          _c("FormControlContentType", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'",
              },
            ],
            attrs: { name: "type" },
            model: {
              value: _vm.formData.type,
              callback: function ($$v) {
                _vm.$set(_vm.formData, "type", $$v)
              },
              expression: "formData.type",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "form__group" }, [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formData.description,
                  expression: "formData.description",
                },
                { name: "validate", rawName: "v-validate" },
              ],
              staticClass: "form__control",
              attrs: {
                id: "summary",
                name: "summary",
                placeholder: "Enter your summary here...",
                required: "",
              },
              domProps: { value: _vm.formData.description },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.formData, "description", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "form__label", attrs: { for: "summary" } },
              [_vm._v("Summary")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form__validation" }, [
              _vm._v(_vm._s(_vm.errors.first("summary"))),
            ]),
          ]),
          _vm._v(" "),
          _c("FileUpload", {
            directives: [{ name: "validate", rawName: "v-validate" }],
            ref: "fileinput",
            attrs: {
              id: "files",
              name: "attachments",
              multiple: true,
              required: "",
            },
            model: {
              value: _vm.formData.attachments,
              callback: function ($$v) {
                _vm.$set(_vm.formData, "attachments", $$v)
              },
              expression: "formData.attachments",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "form__group form__group--submit" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "wait",
                    rawName: "v-wait:disabled",
                    value: ["submit", "files uploading"],
                    expression: '["submit", "files uploading"]',
                    arg: "disabled",
                  },
                ],
                staticClass: "btn",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.back.apply(null, arguments)
                  },
                },
              },
              [_vm._v("Back")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "wait",
                    rawName: "v-wait:disabled",
                    value: ["submit", "files uploading"],
                    expression: '["submit", "files uploading"]',
                    arg: "disabled",
                  },
                ],
                staticClass: "btn btn--primary",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.sendToPreview.apply(null, arguments)
                  },
                },
              },
              [_vm._v("Save & Continue")]
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }